export default __webpack_public_path__ + "static/media/golden gate.9dea1494.svg";